import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AssessmentStatusAttemptEnum, AssessmentWeightType } from '@app/core/models';
import { notNull } from '@app/shared';
import { Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { ModalAuditSelectors } from '../../store';
import { Application, AttemptStudentData, ModalAuditState } from '../../store/modal-audit.state';
import { getAttemptStatus } from '../../utils';

@Component({
  selector: 'app-card-student-active',
  templateUrl: './card-student-active.component.html',
})
export class CardStudentActiveComponent {
  public student$ = new BehaviorSubject<AttemptStudentData>(undefined);
  public application: Application;

  constructor(private _store: Store<ModalAuditState>, private _destroyRef: DestroyRef) {
    this._store
      .select(ModalAuditSelectors.selectStudentActive)
      .pipe(takeUntilDestroyed(this._destroyRef), notNull())
      .subscribe((student) => this.student$.next(student));

    this._store
      .select(ModalAuditSelectors.selectApplication)
      .pipe(takeUntilDestroyed(this._destroyRef), notNull(), distinctUntilChanged(isEqual))
      .subscribe((application) => (this.application = application));
  }

  public get studentScore(): number {
    return [AssessmentStatusAttemptEnum.Finish, AssessmentStatusAttemptEnum.WaitDateResult].includes(
      this.student$.value.status,
    )
      ? this.student$.value.nota_calculada
      : undefined;
  }

  public get isPercent(): boolean {
    return this.application.assessment.weight_type === AssessmentWeightType.Porcentagem;
  }

  public get score(): number {
    return this.application.assessment.score;
  }

  public onGetStatusLabel(student: AttemptStudentData) {
    return getAttemptStatus(student);
  }
}
